<ng-container *ngIf="!this.accessDenied && prop">
  <div class="container-fluid">
    <div class="top-header">
      <app-property-profil [prop]="prop"></app-property-profil>
    </div>
    <!--<div class="row mt-3">
    <div class="col-12 p-0 d-flex property-header">
      <div class="prop-image">
        <img class="img-fluid main-photo" [src]="mainPhoto" alt="Photo principale du bien" />
      </div>
      <div class="prop-badge">
        <app-certification-badge [prop]="prop"></app-certification-badge>
      </div>
      <div class="prop-desc">
        <h1 class="{{titleClass}} text-left">
          {{ prop.name }}
        </h1>
        <div class="text-left">
          <span class="font-weight-bold">Copropriété, {{ allProps.length +' lot'+(allProps.length>1 ? 's' : '') }} :
          </span>
          <ul>
            <li *ngFor="let type of globalAvailablePropTypes; let index=index">
              {{ globalCountPropTypes[type] +' '+ propHelper.getTypeName(type)+(globalCountPropTypes[type]>1 ? 's' :
              '')}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>-->
    <div class="btn-actions d-flex flex-row-reverse m-2">
      <div *ngIf="userHelper.canUpdateProperty(prop)">
        <button mat-mini-fab color="primary" class="ml-2" appTooltip="Voir le lot copropriété"
          [routerLink]="['/property', prop.uid]">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
        <button mat-mini-fab color="primary" class="ml-2" appTooltip="Ajouter un bien à la copropriété"
          (click)="addChild(prop)">
          <mat-icon>add</mat-icon>
        </button>
        <button mat-mini-fab color="primary" class="ml-2" appTooltip="Ajouter des documents" (click)="addDocs()"
          [disabled]="selectedProps.length === 0">
          <mat-icon>note_add</mat-icon>
        </button>
        <button mat-mini-fab color="primary" class="ml-2" appTooltip="Ajouter des photos" (click)="addPhotos()"
          [disabled]="selectedProps.length === 0">
          <mat-icon>add_photo_alternate</mat-icon>
        </button>
        <button mat-mini-fab color="primary" class="ml-2" appTooltip="Modifier des attributs"
          (click)="updateAttributes()" [disabled]="selectedProps.length === 0">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>

    <!-- TOP -->
    <app-filters-property-list (filterData)="filterData = $event" (onDisplayFullColumns)="displayFullColumns = $event"
      [list]="newlist" [parentId]="propId">
    </app-filters-property-list>

    <!--  NEWT TABLE -->
    <app-property-list *ngIf="prop" [propParentId]="prop.uid" [filterData]="filterData" [lightColumns]="lightColumns"
      [fullColumns]="fullColumns" [reload]="reload" (selectedProps)="selectedProps = $event"
      (newList)="newlist = $event" [displayFullColumns]="displayFullColumns" [condoMode]="true"></app-property-list>
  </div>
</ng-container>

<ng-container *ngIf="this.accessDenied">
  <div class="container-fluid text-center mt-5">
    <h2 class="text-center">Autorisation d'accès nécessaire !</h2>
    <p class="mt-5">
      Vous n'êtes pas autorisé à visualiser les informations de ce bien.
    </p>
  </div>
</ng-container>
